export const questions = [
  {
    id: 1,
    question:
      'Do you think the Odisha Government should lift the lockdown after May 3" in the interest of stimulating the local economy?',
    options: ['Yes', 'No', 'Partially, but in phases', 'Can’t say'],
  },
  {
    id: 2,
    question:
      'Do you think Odisha’s economy will recover quickly once the lockdown is lifted?',
    options: [
      'Yes, within 3 months after relaxations are in-place',
      'No, between 3-6 months after relaxations are in-place',
      'Not sure, but feel it will take longer than 6 months',
    ],
  },
  {
    id: 3,
    question:
      'Imagining your everyday life, post the COVID-19 lockdown restrictions, what is the most critical changes do you think may be seen in your general lifestyle (in the next 6 months)?',
    options: [
      'Avoiding public transportation',
      'Giving more attention to personal/family health and hygiene',
      'Maintain social distancing of 1m',
      'Travelling less for workor leisure',
      'Avoid public areas (malls, theaters, crowded areas)',
      'Increased online shopping for products & services',
      'Reduce eating-out in restaurants',
      'Ask employer for allowing more work from home days',
      'Focus on saving more money and spending less',
      'Look for additional sources of income, beyond salary',
      'Minimize duties/time for hired help/ maids for household work',
      'Use more technology (apps, websites) for daily activities',
      'No changes to lifestyle',
    ],
  },
  {
    id: 4,
    question:
      'Will you consciously purchaseany of these products or services online instead of physically going to the facility, because of the COVID-19 / coronavirus pandemic, post-lockdown?',
    options: [
      'Restaurant delivery takeaway (e.g. Swiggy, Zomato)',
      'Clothes',
      'Consumer products (computer, phones, TV etc.)',
      'Groceries (e.g. Big Basket, Amazon etc.)',
      'Furniture (e.g Pepper Fry, Urban Ladder etc.)',
      'Pharmacy (Medicines, health products)',
      'Telemedicine (health consultations over telephone)',
      'Movies',
      'Banking services',
    ],
  },
  {
    id: 5,
    question:
      '.What are the main sourcesof information related to COVID-19 in Odisha?',
    options: [
      'National and Regional TV Newschannels',
      'Daily or weekly newspapers',
      'Government of Odisha official websites',
      'Social media (e.g. Facebook/Twitter/YouTube/WhatsApp)',
      'Radio',
      'Official and government press releases',
      'Medical institutions press releases',
      'Celebrities and social media influencers',
    ],
  },
  {
    id: 6,
    question:
      'Did you visit or download any official government online resources for information related to COVID-19 ?',
    options: [
      'Aarogya Setu Mobile App',
      'Ministry of Health & Welfare - Government of India Website(https://www.mohfw.gov.in/)',
      'MyGov Website (https://www.mygov.in/covid-19)',
      'Odisha COVID Dashboard Mobile App',
      'COVID-19 Odisha State Portal (h_ ttps://covid19.odisha.gov.in/)',
      'Department of Health & Welfare website - Government of Odisha (https://health.odisha.gov.in/)',
      'CMO Twitter & Facebook handles',
      'Information & Public Relations Twitter & Facebook handles',
      'World Health Organization',
    ],
  },
];
